export const Pages = {
     About : 'About',
     Hiring : 'Hiring',
     Hr : 'Hr',
     Home : 'Home',
     Training : 'Training',
}